import { useState } from "react";
import api from "@/lib/api";
import RichText from "@/components/RichText";

// Formulaire réellement fonctionnel — soumet à POST /newsletter/subscribe
// (backend/routers/catalog_router.py), pas un formulaire décoratif. Le
// backend absorbe silencieusement une double inscription (index unique
// shop_id+email) : côté visiteur, un succès s'affiche dans tous les cas.
const DEFAULTS = {
  heading: "Restez informé",
  body: "",
  placeholder_text: "Votre email",
  success_message: "Merci, votre inscription est confirmée !",
};

export default function NewsletterSection({ props = {} }) {
  const t = { ...DEFAULTS, ...props };
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | done | error

  const submit = (e) => {
    e.preventDefault();
    if (!email.trim() || status === "loading") return;
    setStatus("loading");
    api.post("/newsletter/subscribe", { email: email.trim() })
      .then(() => { setStatus("done"); setEmail(""); })
      .catch(() => setStatus("error"));
  };

  return (
    <section className="max-w-[640px] mx-auto px-6 py-section md:py-section-md text-center">
      {t.heading && (
        <RichText
          as="h2"
          className="font-display font-semibold text-[26px] md:text-[30px] leading-tight tracking-[-0.02em] text-ink"
          html={t.heading}
        />
      )}
      {t.body && <RichText as="p" preserveParagraphs className="text-[15px] text-graphite mt-3" html={t.body} />}

      {status === "done" ? (
        <p className="text-[15px] text-ink font-medium mt-6">{t.success_message}</p>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 mt-6">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t.placeholder_text}
            className="flex-1 rounded-btn border-control border-stone bg-white px-4 py-3 text-[14px] text-ink outline-none focus:border-ink transition-colors"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="inline-flex items-center justify-center gap-2 bg-ink text-white px-6 py-3 rounded-btn text-[14px] font-semibold hover:opacity-90 disabled:opacity-50 transition-opacity"
          >
            {status === "loading" ? "Envoi…" : "S'inscrire"}
          </button>
        </form>
      )}
      {status === "error" && (
        <p className="text-[13px] text-error mt-3">Une erreur est survenue, réessayez.</p>
      )}
    </section>
  );
}
